import React, { useRef } from "react"

export type Previous<T> = { last: T; prev: T | undefined; isDifferent: boolean }
type UsePreviousResult<T> = {
    ref: React.MutableRefObject<Previous<T>>
    resetIsDifferent: () => void
}

export const usePreviousIfDifferent = <T>(newValue: T): UsePreviousResult<T> => {
    const ref = useRef<Previous<T>>({
        last: newValue,
        prev: undefined,
        isDifferent: false,
    })

    const last = ref.current.last

    if (JSON.stringify(newValue) !== JSON.stringify(last)) {
        ref.current = {
            last: newValue,
            prev: last,
            isDifferent: true,
        }
    }

    function resetIsDifferent() {
        ref.current.isDifferent = false
    }

    return { ref, resetIsDifferent }
}
